import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 Z M10,18.0952381 C14.4708765,18.0952381 18.0952381,14.4708765 18.0952381,10 C18.0952381,5.52912345 14.4708765,1.9047619 10,1.9047619 C5.52912345,1.9047619 1.9047619,5.52912345 1.9047619,10 C1.9047619,14.4708765 5.52912345,18.0952381 10,18.0952381 Z M10,15.9166667 C9.30964406,15.9166667 8.75,15.3570226 8.75,14.6666667 L8.75,9.66666667 C8.75,8.97631073 9.30964406,8.41666667 10,8.41666667 C10.6903559,8.41666667 11.25,8.97631073 11.25,9.66666667 L11.25,14.6666667 C11.25,15.3570226 10.6903559,15.9166667 10,15.9166667 Z M10,4.25 C10.6903559,4.25 11.25,4.80964406 11.25,5.5 C11.25,6.19035594 10.6903559,6.75 10,6.75 C9.30964406,6.75 8.75,6.19035594 8.75,5.5 C8.75,4.80964406 9.30964406,4.25 10,4.25 Z"
      transform="translate(2 2)"
      fill={fill}
    />
  </g>
);

export default Icon;
